import "../styles/meista.css";

function Meista() {
  return (
    <div class="meista-container" id="meista">
      <div className="meista-vasen">
      </div>
      <div className="meista-oikea">
        <h1>Tietoa meistä</h1>
        <p>
          Tarjoamme IT-infran kokonaisratkaisuja aina kehittämisestä ylläpitoon saakka, 30 vuoden kokemuksella. Yrittäjinä ymmärrämme myös liiketoiminnan sujuvuuden tärkeyden, joten toteutamme ratkaisut yhdessä sovitun aikataulun mukaisesti, silloin kun se teille sopii.</p>
      </div>
    </div>
  );
}

export default Meista;